import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
// Mesmo seletor de cor livre (hex) usado no QR Code (ex.: cor de fundo/título do
// PDF de QR Code em `buckets/pdf`), a pedido do time de produto — troca do
// `ColorPicker` de paleta fixa usado antes.
import PopoverColorPicker from '../../../../components/form/PopoverColorPicker'

const GeneralSection = () => {
  const { t } = useTranslation('tags')
  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="100%" wrapOn="sm">
        <FormItem label={t('name')} field="name" />
      </Col>

      <Col width="100%" wrapOn="sm">
        <FormItem label={t('color')} field="color" Input={PopoverColorPicker} />
      </Col>
    </Grid>
  )
}

export default GeneralSection
